import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const BASE_URL = process.env.REACT_APP_MAIN_URL

export const GetReturns = createAsyncThunk(
  "return/GetReturns",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/return/list/`);
    return data
  }
);

export const AddReturn = createAsyncThunk(
  "return/AddReturn",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/return/create/`, data)
    return response.data
  }
); 

export const UpdateReturn = createAsyncThunk(
  "return/UpdateReturn",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/return/update/${data.id}/`, data)
    return response.data
  }
);

export const DeleteReturn = createAsyncThunk(
  "return/DeleteReturn",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/return/delete/${id}/`)
    return response.status
  }
);

export const GetReturnItems = createAsyncThunk(
  "return/GetReturnItems",
  async (id) => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/return/item/${id}/`)
    return data
  }
);

export const DeleteReturnItem = createAsyncThunk(
  "return/DeleteReturnItem",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/return/item/delete/${id}/`)
    return response.status
  }
);